import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb6ebc8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-mobile2 bg-custom-function2 overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_features_dialog = _resolveComponent("features-dialog")!
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_note_dialog = _resolveComponent("note-dialog")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_features_dialog, null, null, 512), [
        [_vShow, $setup.state.showFeatureDialog]
      ]),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, {
            class: "container-mobile2",
            opacity: 0.4
          }, null, 8, ["opacity"]), [
            [_vShow, $setup.showNote]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_note_dialog, {
            onKnew: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeNote()))
          }, null, 512), [
            [_vShow, $setup.showNote]
          ])
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ])
  ], 64))
}